import { render, staticRenderFns } from "./AddStartupToEventDialog.vue?vue&type=template&id=8b0b5cb4&"
import script from "./AddStartupToEventDialog.vue?vue&type=script&lang=js&"
export * from "./AddStartupToEventDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports